export const appendBuildInfo = async() => {
    const jsBuildInfoScript = document.createElement( "script" );

    jsBuildInfoScript.setAttribute( "class", "buildInfo" );
    jsBuildInfoScript.setAttribute( "data-buildinfo", "X.X.X-93028f69" );
    document.getElementsByTagName( "head" )[0].appendChild( jsBuildInfoScript );
};